<template>
  <div id="app">

    <el-container v-loading.fullscreen.lock="exchangeLoading" element-loading-text="切换身份中"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-header>
        <div id="topFrame">
          <div id="Title">{{ this.$store.state.title }}</div>
          <!-- <div class="EssentialInformation">用户名：{{ Username }}</div> -->
          <div class="EssentialInformation"></div>
          <div class="signoutBox">
            <div>
              <!-- <span>角色名：{{ this.$store.state.role.role_name }}</span> -->
              <span>用户名：{{ Username }}</span>
            </div>
            <el-dropdown @command="handleCommand" :hide-on-click="false">
              <img src="../../assets/set.png" style="height: 25px;width: 25px;cursor: pointer;margin-right: 10px; ">
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="info">
                  <i class="el-icon-user"></i>
                  个人信息
                </el-dropdown-item>
                <el-dropdown-item command="password">
                  <i class="el-icon-edit"></i>
                  修改密码
                </el-dropdown-item>
                <!-- <el-dropdown-item command="performance">
                  <i class="el-icon-postcard"></i>
                  个人绩效
                </el-dropdown-item> -->

                <el-dropdown-item command="exit">
                  <i class="el-icon-switch-button"></i>
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </div>
      </el-header>
      <el-container>

        <!-- 动态渲染菜单开始 -->
        <el-aside width="250px" style="background-color: #283C59;height: calc(100vh - 70px);" key="admin_aside">
          <el-menu router :default-active="$route.path" text-color="#fff" background-color="#283C59"
            active-text-color="#ffd04b" style="width: inherit" key="admin" v-for="(item, i) in menuList" :key="i">

            <el-menu-item v-if="item.url" :index="item.url" style="height: auto;width: 100%;font-weight: 700;"
              class="custom-menu-item">
              <span slot="title">
                <i :class="item.icon" style="color: #409EFF;"></i>
                {{ item.name }}
                <el-badge v-if="item.name === '我的桌面'" :value="toBeDealtWithNmu"
                  v-show="toBeDealtWithNmu > 0"></el-badge>
              </span>
            </el-menu-item>

            <el-submenu v-else style="height: auto;width: 100%" :index="i + ''">
              <template slot="title">
                <span style="font-weight: 700;">
                  <i :class="item.icon" style="color: #409EFF;"></i>
                  {{ item.name }}</span>
              </template>

              <el-menu-item style="text-align: left;" class="selectBox" v-for="(items, s) in item.children"
                :key="s + 30 + ''" :index="items.url">
                <i :class="item.icon" style="color: #07C160;"></i>
                {{ items.name }}
                <el-badge v-if="items.name === '待提交' && items.url === '/person_toBeSubmitted'"
                  :value="toSubmitList.person_num" v-show="toSubmitList.person_num > 0"></el-badge>

                <el-badge v-if="items.name === '待审核' && items.url === '/person_toBeReviewed'"
                  :value="toAuditList.person_num" v-show="toAuditList.person_num > 0"></el-badge>

                <el-badge v-if="items.name === '驳回件' && items.url === '/person_rejection'"
                  :value="rejectList.person_num" v-show="rejectList.person_num > 0"></el-badge>

                <el-badge v-if="items.name === '待提交' && items.url === '/team_toBeSubmitted'"
                  :value="toSubmitList.team_num" v-show="toSubmitList.team_num > 0"></el-badge>

                <el-badge v-if="items.name === '待审核' && items.url === '/team_toBeReviewed'"
                  :value="toAuditList.team_num" v-show="toAuditList.team_num > 0"></el-badge>

                <el-badge v-if="items.name === '驳回件' && items.url === '/team_rejection'" :value="rejectList.team_num"
                  v-show="rejectList.team_num > 0"></el-badge>

                <el-badge v-if="items.name === '待确认'" :value="toAckList" v-show="toAckList > 0"></el-badge>
              </el-menu-item>
            </el-submenu>

          </el-menu>
        </el-aside>
        <!-- 动态渲染菜单结束 -->

        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
    <user-info ref="dialog_userInfo" v-if="dialogUserInfoVisible"></user-info>
    <update-password ref="dialog_updatePass" v-if="dialogUpdatePassVisible"></update-password>
    <Individual ref="dialog_individual" />
  </div>
</template>

<script>
import { bus } from "@/router/main";
import UserInfo from "@/components/pc/userInfo";
import UpdatePassword from "@/components/pc/updatePassword";
import Individual from "@/components/pc/individual";

export default {
  name: "epasNewMenu",
  components: { UpdatePassword, UserInfo, Individual },
  data () {
    return {
      toAuditList: {
        person_num: 0,
        team_num: 0,
        all_num: 0
      },
      toApproveList: {
        person_num: 0,
        team_num: 0,
        all_num: 0
      },
      toAckList: 0,
      rejectList: {
        person_num: 0,
        team_num: 0,
        all_num: 0
      },
      toSubmitList: {
        person_num: 0,
        team_num: 0,
        all_num: 0
      },
      dialogUserInfoVisible: false, //个人信息对话框默认隐藏
      dialogUpdatePassVisible: false, //修改密码对话框默认隐藏
      Username: this.$store.state.userInfo.acc_name,
      exchangeLoading: false,
      minHeight: 0,
      marginLeft: 0,
      flag: true,
      reNum: 0,
      menuList: [],
      toBeDealtWithNmu: 0,
    }
  },

  provide () {
    return {
      getFlag: () => this.flag
    }
  },

  created () {
    // 监听自定义事件
    bus.$on('updateFlag', this.updateFlag);
    this.getBacklog()
    this.getMenuList()
  },

  mounted () {
    if (this.$store.state.sysPower.id === '7' || this.$store.state.sysPower.id === '6') {
      this.$axios.get("/department/Bubbles", { params: {}, }
      ).then((res) => {
        if (res.data.code === 200) {
          this.reNum = res.data.data
        } else {
          this.$message.error(res.data.msg);
          clearTimeout(this.timerRe);
        }
      }).catch((err) => {
        clearTimeout(this.timerRe);
        if (err.response.status === 500) {
          this.$message.error("网络异常，请稍后重试！");
        } else {
          this.$message.error("系统繁忙，请稍后重试！")
        }
      }
      )
      this.watchReNum();
    }
    // this.$router.replace({ path: '/welcome' });
    this.$router.replace({ path: '/toDoList' });
    // this.tipTimer = setInterval(this.selectTodoList, 1000);
    this.tipTimer = setInterval(this.getBacklog, 15000);

  },
  beforeDestroy () {
    // 清除定时器
    clearTimeout(this.tipTimer);
    clearTimeout(this.timerRe);
  },

  methods: {

    getBacklog () {
      this.$axios.get("/home/getBacklog").then((res) => {
        if (res.data.code === 200) {
          this.toBeDealtWithNmu = Object.keys(res.data.data).reduce((acc, key) => acc + res.data.data[key], 0);
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((err) => {
        this.$message.error(err);
      })
    },

    // 获取系统菜单列表
    getMenuList () {
      const userId = this.$store.state.userInfo.id;
      this.$axios.get(`/SysMenu/getMenusByUserId?userId=${userId}`
      ).then((res) => {
        if (res.data.code === 200) {
          this.menuList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((err) => {
        if (err.response.status === 500) {
          this.$message.error("网络异常，请稍后重试！");
        } else {
          this.$message.error("系统繁忙，请稍后重试！")
        }
      })
    },

    menuSelection (index) {
      if (index === '/person_new') {
        bus.$emit('refreshCurrentPage');
      }
    },

    updateFlag () {
      this.flag = false;
    },
    watchReNum () {
      this.timerRe = setInterval(() => {
        this.$axios.get("/department/Bubbles", { params: {}, }
        ).then((res) => {
          if (res.data.code === 200) {
            this.reNum = res.data.data
          } else {
            this.$message.error(res.data.msg);
            clearTimeout(this.timerRe);
          }
        }).catch((err) => {
          clearTimeout(this.timerRe);
          if (err.response.status === 500) {
            this.$message.error("网络异常，请稍后重试！");
          } else {
            this.$message.error("系统繁忙，请稍后重试！")
          }
        })
      }, 1000);
    },

    selectTodoList () {
      if (this.$store.state.sysPower.id === '3' || this.$store.state.sysPower.id === '4') { // 主管或主任
        this.$axios.post(
          "/audit/toApprovedNum",
          { id: this.$store.state.role.id }).then((res) => {
            if (res.data.code === 200) {
              if (res.data.data !== null) {
                this.toApproveList = res.data.data;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch((err) => {
            if (err.response.status === 500) {
              this.$message.error("网络异常，请稍后重试！");
            } else {
              this.$message.error("系统繁忙，请稍后重试！");
            }
          })
      } else if (this.$store.state.sysPower.id === '5') {
        this.$axios.post(
          "/report/toAuditNum",
          { id: this.$store.state.userInfo.id }).then((res) => {
            if (res.data.code === 200) {
              if (res.data.data !== null) {
                this.toAuditList = res.data.data;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch((err) => {
            if (err.response.status === 500) {
              this.$message.error("网络异常，请稍后重试！");
            } else {
              this.$message.error("系统繁忙，请稍后重试！");
            }
          })

        this.$axios.post(
          "/report/toSubmitNum",
          { id: this.$store.state.userInfo.id }).then((res) => {
            if (res.data.code === 200) {
              if (res.data.data !== null) {
                this.toSubmitList = res.data.data;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch((err) => {
            if (err.response.status === 500) {
              this.$message.error("网络异常，请稍后重试！");
            } else {
              this.$message.error("系统繁忙，请稍后重试！");
            }
          })
        this.$axios.post(
          "/report/toAck",
          { id: this.$store.state.userInfo.id, page: 1, pageSize: 10 }).then((res) => {
            if (res.data.code === 200) {
              if (res.data.data !== null) {
                this.toAckList = res.data.data.total;
              } else {
                this.toAckList = 0;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch((err) => {
            if (err.response.status === 500) {
              this.$message.error("网络异常，请稍后重试！");
            } else {
              this.$message.error("系统繁忙，请稍后重试！");
            }
          })

        this.$axios.post(
          "/report/rejectNum",
          { id: this.$store.state.userInfo.id }).then((res) => {
            if (res.data.code === 200) {
              if (res.data.data !== null) {
                this.rejectList = res.data.data;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch((err) => {
            if (err.response.status === 500) {
              this.$message.error("网络异常，请稍后重试！");
            } else {
              this.$message.error("系统繁忙，请稍后重试！");
            }
          })
      }
    },

    handleCommand (command) {  //下拉菜单事件
      if (command === "info") {
        this.dialogUserInfoVisible = true;
        this.$nextTick(() => {
          this.$refs.dialog_userInfo.init();
        })
      } else if (command === "password") {
        this.dialogUpdatePassVisible = true;
        this.$nextTick(() => {
          this.$refs.dialog_updatePass.init();
        })
      } else if (command === "exit") {
        this.$axios.get("/users/logout?token=" + this.$store.state.token).then(() => { //清除token
          this.$store.commit('RESET_STATE');
          localStorage.removeItem('token'); // 清除本地存储中的 token
          window.localStorage.removeItem("vuex");
        }).catch(() => {
          this.$store.commit('RESET_STATE');
          localStorage.removeItem('token'); // 清除本地存储中的 token
          window.localStorage.removeItem("vuex");
        })
        this.$router.replace({ path: '/' });
      } else if (command === 'performance') {
        this.$refs.dialog_individual.dialogVisible = true
      }
    },
    changeRoleCommand (command) {//切换角色下拉菜单
      this.exchangeLoading = true;
      this.$store.commit('setRole', command)
      let params = "token=" + this.$store.state.token + "&role_id=" + command.id;
      /**修改角色后切换接口权限,修改this.$store.state.token */
      this.$axios.get("/users/switchRole?" + params).then((res) => {
        if (res.data.code === 200) {
          this.$store.commit('setToken', res.data.data);
          /*******************根据角色id获得系统权限****************************/
          this.$axios.get("/roles/sysPower?role_id=" + this.$store.state.role.id).then((res) => {//
            if (res.data.code === 200) {
              this.$store.commit('setSysPower', res.data.data);//获取sysPower
              // 强制刷新界面，因为如果当前在welcome界面的话，界面不会进行跳转，工作提醒功能失效，虽然刷新界面可能会引发性能问题，但是目前应该不至于
              // this.$router.replace({path: '/welcome'});
              this.$router.go(0);
              this.exchangeLoading = false;
            } else {
              this.$message.error("获取系统权限失败");
              this.exchangeLoading = false
            }
          })
        } else {
          this.$message.error(res.data.msg);
        }
      })

    }
  }
}
</script>

<style scoped>
::v-deep .el-submenu .el-menu-item {
  padding-left: 105px !important
}

::v-deep .el-menu {
  text-align: left;
}

#topFrame {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #16253E;
  position: fixed;
  top: 0;
  left: 0;
  width: inherit;
  height: inherit;
  color: aliceblue;
  min-width: 1100px;
}

#Title {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-weight: 700;
  width: 40%;
  height: 100%;
  font-size: 30px;
  margin: 0 80px;
}

.EssentialInformation {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  text-align: center;
  font-size: 15px;
  width: 40%;
  height: 30px;
  line-height: 30px;
  margin: 0 30px;
}

.signoutBox {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /*font-size: 13px;*/
  font-size: 15px;
  line-height: 100%;
  /*width: 10%;*/
  width: 15%;
}

.el-menu-item.is-active {
  background-color: #16253E !important;
}

.el-aside {
  display: block;
  position: absolute;
  top: 70px;
  bottom: 0;
}

.el-aside::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}

::v-deep .el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  /* padding: 0 55px; */
  padding-left: 40px !important;
  min-width: 200px;
}

.el-main {
  text-align: center;
  position: absolute;
  left: 250px;
  right: 0;
  top: 70px;
  bottom: 0;
  overflow: auto;
  min-width: 1100px;
  min-height: 700px;
  background-color: #F4F5F9;
  padding: 0;
}

.el-header {
  padding: 0;
  width: 100%;
  height: 70px !important;
  background-color: #16253E;
}

#app {
  position: fixed;
  display: flex;
  width: 100%;
  height: 100%;
}

.circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.number {
  font-size: 12px;
  color: #333;
}
</style>
